module.exports = __webpack_public_path__ + "img/sspp.8dd3af2c.jpg";